module.exports = __webpack_public_path__ + "img/best-sellers.09fa4225.png";